import {GROUP_ID_KINDS} from '../import-payload';
import {GroupCardDescriptor, GroupCardModel, GroupHeaderFieldDef, GroupKind} from './group-card.model';

/** The title a card shows on the mapping list as one line of `text`, and
 * the event type name it carries (`null` for none). */
export interface GroupCardListTitle {
  text: string;
  typeName: string | null;
}

/**
 * The title of card `model`, number `index` among its kind's cards (from
 * 1), on the mapping list: its kind's title and number, "Alternativt
 * nummer 1", as the live preview labels a card by `titleKey` and number,
 * and, for an event card whose type is picked, the type's name after it:
 * "Historikkhendelse 1 · Produksjon".
 */
export function groupCardListTitle(
    descriptor: GroupCardDescriptor, model: GroupCardModel, index: number,
    translate: (key: string) => string): GroupCardListTitle {
  const kindTitle = `${translate(descriptor.titleKey)} ${index}`;
  const isEvent = !(GROUP_ID_KINDS as readonly GroupKind[]).includes(descriptor.kind);
  const typeName = isEvent ? pickedTypeName(descriptor, model) : null;
  return {text: typeName ? `${kindTitle} · ${typeName}` : kindTitle, typeName};
}

/** The name of the option a header select has picked; `null` for none. */
export function headerOptionName(header: GroupHeaderFieldDef, picked: string | null | undefined): string | null {
  const option = header.options.find(o => o.id === picked);
  return option ? (option.leaf_name || option.name) : null;
}

function pickedTypeName(descriptor: GroupCardDescriptor, model: GroupCardModel): string | null {
  const typeHeader = descriptor.header.find(h => h.required);
  return typeHeader ? headerOptionName(typeHeader, model.headerControls[typeHeader.key]?.value) : null;
}
